@if (training) {
  <div class="outer-wrapper">
    <div class="container pb-4 pb-sm-4">
      <div class="back-button">
        <a color="primary" routerLink="/e-learning/trainings/available" translate>
          <i-feather class="me-2" name="arrow-left"></i-feather>SINGLE_TRAINING.BACK_BUTTON
        </a>
      </div>
      <div class="row pt-0 pt-sm-5">
        <div class="col-md-12 col-lg-7 px-0 px-sm-3">
          @if (training.lead_video?.embed_url) {
            <app-video [video]="training.lead_video"></app-video>
          }
          @if (training.lead_image && !training.lead_video?.embed_url) {
            @if (training.lead_image.url) {
              <img
                [appSrcset]="training.lead_image.url"
                [pxWidth]="600"
                [alt]="training.lead_image.alt"
                class="img-fluid" />
            }
          }
        </div>
        <div class="col pt-3 pt-lg-0">
          <h1>{{training.name}}</h1>
          <span class="d-flex align-items-center mb-md-2 training-meta">
            @for (trainer of training.trainers; track trainer) {
              <div class="trainer-name mr-2">
                <mat-icon svgIcon="trainer_v2"></mat-icon>
                <span>{{trainer.name}}</span>
              </div>
            }
            @if (training.duration) {
              <app-training-duration
                class="ms-3 ms-md-0 d-block mr-2"
              [duration]="training.duration"></app-training-duration>
            }
            <div class="div">
              <mat-icon svgIcon="chapters_v2" class="mr-2"></mat-icon>
              <span>{{training.sessions?.length}} {{'SINGLE_TRAINING.CHAPTER_NO' | translate}}</span>
            </div>
          </span>
          <div class="d-block mt-4 description" [innerHTML]="training.description | prismicHtml | hyphenateHtml | async"></div>
          <div class="selling-points col d-flex">
            @if (learningsAvailable(training)) {
              <div class="col learnings">
                <ul class="column-list p-0 m-0">
                  @for (learning of training.learnings; track learning) {
                    <li class="d-flex flex-align-items-start training-highlight mb-2">
                      <mat-icon svgIcon="check_v2"></mat-icon>
                      <span>{{learning}}</span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
